import React, { memo, useCallback } from 'react';
import clsx from 'clsx';

import scss from './LegendItem.module.scss';

const LegendItem = ({ title, onClick, isActive = true, inFocus, color, disabled, domain, myCompany }) => {
  const handleCLick = useCallback(() => {
    if (onClick) {
      onClick(domain);
    }
  }, [onClick, domain]);

  return (
    <div
      className={clsx(
        scss.legendItem,
        !!onClick && scss.clickable,
        !isActive && scss.inactive,
        inFocus && scss.inFocus,
        myCompany && scss.myCompany,
        disabled && scss.disabled,
      )}
      onClick={handleCLick}
      role='presentation'>
      {color ? <div className={scss.legendMarker} style={{ backgroundColor: color }} /> : null}
      <div className={scss.legendText}>{title}</div>
    </div>
  );
};

export default memo(LegendItem);
